import React from 'react';
import { Root, StyledCard, Col, ImageBox, LogoArea } from './styled';
import { useHistory } from 'react-router-dom';
import style from './style.module.scss';
import VerifyUserContent from './VerifyUserContent';
import { useQueryString } from '../hooks/useQueryString';

const VerifyUser: React.FC = () => {
  const query = useQueryString();
  const { push } = useHistory();
  const code = query.get('code') || query.get('confirmation_code') || '';
  const email = decodeURIComponent(
    (query.get('email') || query.get('username') || '').replace(/ /g, '+')
  );

  if (!email) {
    // this should not happen
    push('/login');
    return null;
  }

  return (
    <Root>
      <div className={style.login_page__container}>
        <Col>
          <ImageBox />
          <LogoArea className={style.logo__wrapper}>
            <div className={style.logo} />
          </LogoArea>
        </Col>
        <StyledCard className={`card ${style.login__wrapper}`}>
          <VerifyUserContent code={code} email={email} />
        </StyledCard>
      </div>
    </Root>
  );
};

export default VerifyUser;
